import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "flex-container-row gap20 portal-message portal-notification"
}
const _hoisted_3 = {
  key: 1,
  class: "flex-container-row gap20 portal-message portal-warning"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_close_button_header = _resolveComponent("close-button-header")!

  return (_ctx.showAnyMessage)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showPortalNotification)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", null, _toDisplayString(_ctx.portalNotification), 1),
              _createVNode(_component_close_button_header, { onClose: _ctx.hideNotification }, null, 8, ["onClose"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showPortalWarning)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", null, _toDisplayString(_ctx.portalWarning), 1),
              _createVNode(_component_close_button_header, { onClose: _ctx.hideWarning }, null, 8, ["onClose"])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}